import { isTransientError } from '@/adapters/graphql/transientError';

const DEFAULT_ATTEMPTS = 3;
const DEFAULT_DELAY_MS = 500;

interface RetryOptions {
  attempts?: number;
  delayMs?: number;
  sleep?: (ms: number) => Promise<void>;
}

const defaultSleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

const retryOnTransientError = async <T>(
  operation: () => Promise<T>,
  options: RetryOptions = {},
): Promise<T> => {
  const attempts = options.attempts ?? DEFAULT_ATTEMPTS;
  const delayMs = options.delayMs ?? DEFAULT_DELAY_MS;
  const sleep = options.sleep ?? defaultSleep;

  const attempt = async (current: number): Promise<T> => {
    try {
      return await operation();
    } catch (error) {
      if (!isTransientError(error) || current >= attempts) {
        throw error;
      }

      await sleep(delayMs * current);

      return attempt(current + 1);
    }
  };

  return attempt(1);
};

export { retryOnTransientError };
